/** Width of a heating field on wide screens. */
export const PRIMARY_FIELD_WIDTH = '39.6rem'
